import React from 'react';
import axios from 'axios';
import { Outlet, useNavigate } from 'react-router';

import Breadcrumbs from '../Components/Breadcrumbs';
import Loading from '../Components/Loading';

import styles from '../styles/Index.module.css';

export default function IndexLayout() {
    const navigate = useNavigate();

    const [reload, setReload] = React.useState(true);
    const [loading, setLoading] = React.useState(true);
    const [dbStatus, setDbStatus] = React.useState('Загрузка...');
    const [extraStep, setExtraStep] = React.useState(null);

    React.useEffect(() => {
        setLoading(true);

        const fetchData = async () => {
            try {
                const response = await axios.get('/api/health');
                if (response.status === 200) {
                    setDbStatus('Подключено к серверу');
                }
            } catch (err) {
                setDbStatus('Отсутствует подключение к серверу');
                console.log('Database connection error:', err);
            } finally {
                setLoading(false);
                setReload(false);
            }
        };
  
        fetchData();
    }, [reload]);

    const steps = [
        { label: 'Главная', onClick: () => navigate('/') },
        ...(extraStep ? [extraStep] : []),
    ];

    const [headerStatus, setHeaderStatus] = React.useState('full');
    const changeHeaderStatus = () => {
        headerStatus=='full' ? setHeaderStatus('miniSide') : setHeaderStatus('full');
    };

    React.useEffect(() => {
        const handleResize = () => {
        if (window.innerWidth < 1020) {
            setHeaderStatus('miniSide');
        } else {
            setHeaderStatus('full');
        }
        };

        handleResize();

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [setHeaderStatus]);

    return (
        <div className={styles.pageWrapper}>
            <div className={`${styles.headerWrapper} ${headerStatus=='miniSide' ? styles.miniHeader : ''}`}>
                <div className={styles.header}>
                    <img 
                        src='/img/logo/Alians_symbol_black_bg.png' 
                        alt='-' 
                        style={{width: '40px'}}
                        onClick={() => navigate('/')}
                    />
                    <ul className={styles.nav}>
                        <li
                            onClick={() => navigate('/')}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 18 18"><title>house 2</title><g stroke-width="1.5" fill="none" stroke="currentColor" class="nc-icon-wrapper"><line x1="9" y1="16" x2="9" y2="12.75" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"></line><path d="M3.145,6.2l5.25-3.99c.358-.272,.853-.272,1.21,0l5.25,3.99c.249,.189,.395,.484,.395,.796v7.254c0,1.105-.895,2-2,2H4.75c-1.105,0-2-.895-2-2V6.996c0-.313,.146-.607,.395-.796Z" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
                            <p>Главная</p>
                        </li>
                        <li
                            onClick={() => navigate('/auth/login')}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 18 18"><title>arrow door in</title><g stroke-width="1.5" fill="none" stroke="currentColor" class="nc-icon-wrapper"><path d="M7.25,5.75V3.25c0-.552,.448-1,1-1h6.5c.552,0,1,.448,1,1V14.75c0,.552-.448,1-1,1h-6.5c-.552,0-1-.448-1-1v-2.5" stroke-linecap="round" stroke-linejoin="round"></path><polyline points="4 11.75 6.75 9 4 6.25" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"></polyline><line x1="6.75" y1="9" x2=".75" y2="9" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"></line><path d="M15.543,2.648l-3.321,2.059c-.294,.182-.473,.504-.473,.85v6.887c0,.346,.179,.667,.473,.85l3.322,2.06" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>
                            <p>Войти в учётную запись</p>
                        </li>
                        <li
                            onClick={() => navigate('/auth/registration')}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 18 18"><title>square plus</title><g stroke-width="1.5" fill="none" stroke="currentColor" class="nc-icon-wrapper"><rect x="2.75" y="2.75" width="12.5" height="12.5" rx="2" ry="2" stroke-linecap="round" stroke-linejoin="round"></rect><line x1="5.75" y1="9" x2="12.25" y2="9" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"></line><line x1="9" y1="5.75" x2="9" y2="12.25" stroke-linecap="round" stroke-linejoin="round" stroke="currentColor"></line></g></svg>
                            <p>Зарегистрироваться</p>
                        </li>
                        <li
                            onClick={() => navigate('/send-feedback')}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" height="18" width="18" viewBox="0 0 18 18"><title>msg writing</title><g stroke-width="1.5" fill="none" stroke="currentColor" class="nc-icon-wrapper"><path d="M9,1.75C4.996,1.75,1.75,4.996,1.75,9c0,1.319,.358,2.552,.973,3.617,.43,.806-.053,2.712-.973,3.633,1.25,.068,2.897-.497,3.633-.973,.489,.282,1.264,.656,2.279,.848,.433,.082,.881,.125,1.338,.125,4.004,0,7.25-3.246,7.25-7.25S13.004,1.75,9,1.75Z" stroke-linecap="round" stroke-linejoin="round"></path><path d="M9,10c-.552,0-1-.449-1-1s.448-1,1-1,1,.449,1,1-.448,1-1,1Z" opacity=".75" stroke="none" fill="currentColor"></path><path d="M5.5,10c-.552,0-1-.449-1-1s.448-1,1-1,1,.449,1,1-.448,1-1,1Z" stroke="none" fill="currentColor"></path><path d="M12.5,10c-.552,0-1-.449-1-1s.448-1,1-1,1,.449,1,1-.448,1-1,1Z" opacity=".5" stroke="none" fill="currentColor"></path></g></svg>
                            <p>Обратиться в поддержку</p>
                        </li>
                    </ul>
                    <div className={styles.bottom}>
                        <span 
                            className={`${styles.iconWithDescriptionTitle} ${loading && styles.unactive}`}
                            style={{alignItems: 'start'}}
                        >
                            {loading ? <Loading type='inline' />
                            :
                            <>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#e9e9e9" viewBox="0 0 256 256"><path d="M144,204a16,16,0,1,1-16-16A16,16,0,0,1,144,204ZM239.61,83.91a176,176,0,0,0-223.22,0,12,12,0,1,0,15.23,18.55,152,152,0,0,1,192.76,0,12,12,0,1,0,15.23-18.55Zm-32.16,35.73a128,128,0,0,0-158.9,0,12,12,0,0,0,14.9,18.81,104,104,0,0,1,129.1,0,12,12,0,0,0,14.9-18.81ZM175.07,155.3a80.05,80.05,0,0,0-94.14,0,12,12,0,0,0,14.14,19.4,56,56,0,0,1,65.86,0,12,12,0,1,0,14.14-19.4Z"></path></svg>
                            <p 
                                className={styles.descriptionTitle} 
                                style={{cursor: 'default'}}
                            >
                                {dbStatus}
                            </p>
                            </>}
                            <p 
                                className={styles.descriptionTitle}
                                onClick={() => {
                                    if (loading) {
                                        return;
                                    } else {
                                        setReload(true);
                                    }
                                }}
                            >
                                Обновить
                            </p>
                        </span>
                    </div>
                </div>
            </div>
            <div className={styles.mainWrapper}>
                <div className={styles.main}>
                    <Breadcrumbs steps={steps} />
                    <Outlet context={{ setExtraStep }} />
                </div>
            </div>
        </div>
    );
}